import type { ITTDSubAdvertiser } from '@feathr/blackbox';
import type { ITanStackTableProps } from '@feathr/components';

export type TAdvertiserSort = NonNullable<ITanStackTableProps<ITTDSubAdvertiser>['sort']>;

export const INITIAL_ADVERTISER_SORT: TAdvertiserSort = [{ desc: false, id: 'name' }];

/** Compares two advertisers by the sorted column's field, A to Z by letter whatever the case. */
export function compareAdvertisers(
  a: ITTDSubAdvertiser,
  b: ITTDSubAdvertiser,
  sort: TAdvertiserSort,
): number {
  const [{ desc, id }] = sort;
  const key = id as keyof ITTDSubAdvertiser;
  const result = (a[key] ?? '').localeCompare(b[key] ?? '', undefined, { sensitivity: 'base' });
  return desc ? -result : result;
}

/** The table always shows one sorted column, so a cleared sort goes back to Advertiser A to Z. */
export function getNextAdvertiserSort(nextSort: TAdvertiserSort): TAdvertiserSort {
  return nextSort.length ? nextSort.slice(-1) : INITIAL_ADVERTISER_SORT;
}
